import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Button, Text } from '@fragments';
import { IconArrowUpRight, IconPlus } from '@tabler/icons-react';
import './styles.scss';

// The questions a visitor asks before giving the @ (`landingFaq_<key>_q` / `_a`).
const QUESTIONS = ['what', 'generic', 'free', 'credits', 'profile', 'publish', 'sounds', 'cancel'];

// One question open at a time; each is a button that discloses its answer.
export default function Faq({ t, copy, reveal }) {
  const [open, setOpen] = useState(QUESTIONS[0]);
  const help = () => window.open('https://help.ginastee.com', '_blank', 'noopener,noreferrer');
  return <motion.section className="studio-landing-faq" aria-labelledby="studio-landing-faq" {...reveal}>
    <header className="studio-landing-faq__heading">
      <Text.h2 id="studio-landing-faq" weight={500} contrast={10}>{t('landingFaqTitle')}</Text.h2>
      <Text.p contrast={7}>{t('landingFaqText')}</Text.p>
      <Button variant="text" color="overlay" endIcon={<IconArrowUpRight />} onClick={help}>{t('landingFaqHelp')}</Button>
    </header>
    <div className="studio-landing-faq__list">
      {QUESTIONS.map(key => {
        const expanded = open === key;
        return <div key={key} className={`studio-landing-faq__item ${expanded ? 'is-open' : ''}`}>
          <h3 className="studio-landing-faq__question">
            <button type="button" id={`studio-faq-${key}`} aria-expanded={expanded} aria-controls={`studio-faq-${key}-answer`} onClick={() => setOpen(expanded ? null : key)}>
              <Text.span weight={500} contrast={expanded ? 10 : 9}>{t(`landingFaq_${key}_q`)}</Text.span>
              <IconPlus className="studio-landing-faq__icon" aria-hidden="true" />
            </button>
          </h3>
          <AnimatePresence initial={false}>
            {expanded && <motion.div key="answer" id={`studio-faq-${key}-answer`} role="region" aria-labelledby={`studio-faq-${key}`} className="studio-landing-faq__answer"
              initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.2, ease: 'easeOut' }}>
              <Text.p contrast={7}>{t(`landingFaq_${key}_a`, copy)}</Text.p>
            </motion.div>}
          </AnimatePresence>
        </div>;
      })}
    </div>
  </motion.section>;
}
